import React, { useState, useEffect } from 'react';
import { STAGES } from '../../utils/constants';
import { generateMockVehicles } from '../../utils/mockData';
import StageColumn from '../../components/StageColumn';
import MetricsHeader from '../../components/MetricsHeader';

// Embedded Fitment Flow — reuses MetricsHeader + StageColumn grid without
// the outer full-screen chrome/header/footer from the standalone Dashboard.
const FitmentFlowEmbed = () => {
  const [vehicles, setVehicles] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => { setVehicles(generateMockVehicles()); }, []);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="h-full flex flex-col min-h-0">
      <MetricsHeader vehicles={vehicles} currentTime={currentTime} />
      <div className="flex-1 min-h-0 overflow-hidden grid grid-cols-7 gap-3">
        {STAGES.map((stage) => {
          const stageVehicles = vehicles.filter((v) => v.stageId === stage.id);
          return (
            <StageColumn
              key={stage.id}
              stage={stage}
              vehicles={stageVehicles}
              currentTime={currentTime}
              isFocusMode={false}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FitmentFlowEmbed;
